import "./header.css";
import React, { useCallback, useState } from "react";
import { Row, Menu, Dropdown } from "antd";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentImage } from "../../model/reducer/categoryImage";
import styles from './ProductCategory.module.css';

const ProductCategory = (props) => {
  const { category } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [baseIndex, setSaseIndex] = useState(-1)
  const [linkTag, setLinkTag] = useState(false)
  const filter = useSelector((state) => state.productFilter);
  const mainMenu = useSelector((state) => state.mainMenu.mainMenu);

  const onClickMainMenu = useCallback(
    (child2, index) => {
      setLinkTag(false);
      setSaseIndex(index);
      navigate(`/category/${child2.slug}`);
      dispatch(setCurrentImage({ image: child2.image_url, categoryName: child2.name }))
    },
    [dispatch, navigate]
  );
  const onClickSeconMenu = useCallback(
    (child2, index) => {
      const updatedPathSegments = window.location.pathname.split("/").filter(Boolean);
      const categorySlug = location.pathname.includes('category/') ? updatedPathSegments[updatedPathSegments.length - 1] : '';
console.log(child2.parent_slug === updatedPathSegments[1],'child2.parent_slug === updatedPathSegments[1]',child2.parent_slug, updatedPathSegments[1])
      setLinkTag(false);
      setSaseIndex(index);
      navigate(`/category/${categorySlug && child2.parent_slug === updatedPathSegments[1] ? `${categorySlug}/${child2.slug}` : child2.slug}`);
      dispatch(setCurrentImage({ image: child2.image_url, categoryName: child2.name }));
    },
    [dispatch, navigate]
  );

  const onClickHomeLink = () => {
    setLinkTag(true)
    setSaseIndex(-1);
  }

  const firstMenu = useCallback(
    (propsItem, index) => {
      return (
        <Menu>
          {propsItem?.name !== "Grocery2" &&
            propsItem?.has_child &&
            propsItem?.cat_active_childs?.map((child2) => {
              return (
                <Menu.Item key={child2?.id}>
                  <span class="ant-dropdown-trigger" onClick={() => onClickSeconMenu(child2, index)}>{child2?.name}</span>
                </Menu.Item>
              );
            })}
        </Menu>
      );
    },
    []
  );

  return (
    <div className={`${styles.containerfluid} container-fluid`}>
      <Row style={{ display: "flex", flexWrap: "wrap", alignItems: "center", width: '100%' }}>
        <div className={styles.mainLink}>
          <Link
            onClick={onClickHomeLink}
            className={`linkTag homeLink ${linkTag ? "baseCategory" : ''}`}
            to="/"
          >
            Home
          </Link>
        </div>

        {category?.category?.map((child1, index) => {
          if (!child1.has_child) return
          return (
            <div placement="bottomLeft" className={styles.firstMenu} key={child1?.id}>
              <Dropdown
                overlay={firstMenu(child1, index)}
                trigger={['hover']}
                className={`${styles.firstMenu} ${!linkTag && (baseIndex === index || child1?.id === filter?.parent_id) ? styles.baseCategory : ''}`}
              >
                <span onClick={() => onClickMainMenu(child1, index)}>
                  {child1?.name}
                </span>
              </Dropdown>
            </div>
          );
        })}
      </Row>
    </div>
  );
};

export default ProductCategory;
